import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { experienceData } from '../../interfaces/services-data';
import { PermisionUser, PermisionUserUpdate } from '../../interfaces/authorize-user.interfaces';
import { PermisionUserUpdateByProfile } from 'src/app/features/experiences/interfaces/authorize-user.model';

@Injectable({
  providedIn: 'root'
})
export class ExperiencesService {

  constructor(private http: HttpClient) { }

  /* Crear Experiencia */
  create(data: experienceData): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/create`, data);
  }

  /* Actualizar Experiencia */
  update(data: experienceData, experienceId: number): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/${experienceId}/update`, data);
  }

  /* Crear Temporada */
  createSeason(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/season/create`, data);
  }

  /* Actualizar Temporada */
  updateSeason(data: any, seasonId: number): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/season/${seasonId}/update`, data);
  }

  /* Crear Imagenes */
  imageCreate(data: any[]): Observable<any> {

    const formData = new FormData();

    data.forEach((media, index) => {
      const file = this.__dataURIToBlob(media.base64);
      formData.append('array_files', file, media.name);
      formData.append(`media[${index}][name]`, media.name);
      formData.append(`media[${index}][experience_id]`, media.experience_id);
      formData.append(`media[${index}][subcategory_id]`, media.subcategory_id);
    });

    return this.http.post(`${environment.apiBase}v1/experience/images/create`, formData);
  }

  /* Crear Precios */
  createPricing(data: any, experienceId: number): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/${experienceId}/pricing/create`, data);
  }

  /* Actualizar Precios */
  updatePricing(data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/pricing/update`, data);
  }

  /* Crear Función */
  createFunction(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/function/create`, data);
  }
  updateFunction(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/function/${id}/update`, data);
  }

  /* Generar Cortesias */
  generateCourtesy(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/courtesy/generate`, data);
  }

  /* Generar Usuario para cortesia */
  generateCourtesyUser(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/user/register-courtesy`, data);
  }

  /* Generar Codigo de Puerta */
  generatePortCode(functionId: number): Observable<any> {
    return this.http.get(`${environment.apiBase}v1/experience/function/generate-port-code/${functionId}`);
  }

  /* Crear Promocion */
  createPromotion(experience_id: any, data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/${experience_id}/promotion/create`, data);
  }
  // PUT /v1/experience/{experience_id}/promotion/{promotion_id}/update
  updatePromotion(experience_id: any, promotion_id: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/${experience_id}/promotion/${promotion_id}/update`, data);
  }

  /* Reenviar Ticket */
  forwardTicket(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/ticket/forward`, data);
  }

  /* Control de Acceso Funcion */
  controlExit(ticket_code: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/ticket/control-exit/${ticket_code}`, data);
  }

  /* Control de Acceso Funcion */
  validateTicket(data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/ticket/validate-ticket`, data);
  }

  experienceMedia(experienceId: any, data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/${experienceId}/media/images`, data);
  }

  experienceYoutube(data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/media/youtube`, data);
  }

  deleteImage(data: any): Observable<any> {
    return this.http.delete(`${environment.apiBase}v1/experience/media/images`, {
      body: data
    });
  }
  getExperienceRoles(user_id: any, experience_id: any): Observable<PermisionUser[]> {
    return this.http.get(`${environment.apiBase}v1/user/${user_id}/experience/${experience_id}/roles`).pipe(
      map((res: any) => res.data)
    );
  }

  updateRoles(idUser: number, data: PermisionUserUpdate): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/user/${idUser}/roles/update`, data);
  }

  updateRolesByRoles(idUser: number, data: PermisionUserUpdateByProfile): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/user/${idUser}/roles/update`, data);
  }

  assignRolesByRoles(idUser: number, data: PermisionUserUpdateByProfile): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/user/${idUser}/roles/assign`, data);
  }

  coincidencesSlug(slug: any): Observable<any> {
    return this.http.get(`${environment.apiBase}v1/experience/coincidences`, { params: { slug: slug } });
  }
  // POST /v1/experience/{id}/payment-method-experience/create
  createPaymentMethodExperience(idExperience: any, data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/${idExperience}/payment-method-experience/create`, data);
  }
  // PUT  /v1/experience/{id}/payment-method-experience/update
  updatePaymentMethodExperience(idExperience: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/${idExperience}/payment-method-experience/update`, data);
  }
  // PUT /v1/experience/{id}/payment-method-function/update
  updatePaymentMethodFunction(idExperience: any, data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/${idExperience}/payment-method-function/update`, data);
  }

  // POST /v1/experience/{id}/payment-method-function/update
  createPaymentMethodFunction(idExperience: any, data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/${idExperience}/payment-method-function/create`, data);
  }

  // POST /v1/experience/payment-methods-function/create
  createPaymentMethodFunctionAll(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/payment-methods-function/create`, data);
  }
  // PUT /v1/experience/payment/delete
  deletePaymentMethodFunction(data: any): Observable<any> {
    return this.http.put(`${environment.apiBase}v1/experience/payment/delete`, data);
  }

  listAll(data: any): Observable<any> {
    let params: any = {}

    Object.keys(data).forEach(key => {
      if (data[key] != null) {
        if (key == 'page') {
          console.log(data[key])
          params[key] = +data[key];
        } else {
          params[key] = data[key];
        }
      }
    });

    return this.http.get(`${environment.apiBase}v1/experience/all`, { params: params });

  }

  getSteps(id: any): Observable<any> {
    return this.http.get(`${environment.apiBase}v1/experience/${id}/steps`);
  }
 
  saveSteps(data: any): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/experience/steps`, data);
  }
 
  getExperienceBySlug(slug: string): Observable<any> {
    return this.http.get(`${environment.apiBase}v1/experience/slug/${slug}`);
  }

  private __dataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
  }

  private __blobTodataURI(blob: Blob) {
    return new Promise(r => { let a = new FileReader(); a.onload = r; a.readAsDataURL(blob) }).then((e: any) => e.target.result);
  }
}
